export const primarycolor='#F3350C'
